/* eslint-disable no-underscore-dangle */
import Renderer from './AllowSiteAutoAssignmentRenderer';

import _ from 'lodash';

const DefaultColumnComponent = require('@gluenetworks/steve_ui_widgets').GridGl
  .DefaultColumnComponent;

class AllowSiteAutoAssignmentComponent extends DefaultColumnComponent {
  /**
   * @param {*} value - AllowSiteAutoAssignment field value;
   * @param {Object} context - AllowSiteAutoAssignment field definition data (dataType, typeInfo and so on )
   */
  constructor(value, context = {}) {
    super(value);
    this._value = value;
    this._context = context;
    this._dataType = context.dataType;
    this._renderer = new Renderer(this);
    this._registerListeners();
  }

  /* ***************************************** */
  /* START PRIVATE COMPONENT MODEL METHODS   */
  /* ***************************************** */

  _registerListeners() {}

  _unregisterListeners() {}

  /* ***************************************** */
  /* END PRIVATE COMPONENT MODEL METHODS     */
  /* START PUBLIC COMPONENT MODEL METHODS    */
  /* ***************************************** */

  get renderer() {
    return this.getRenderer();
  }

  getRenderer() {
    return this._renderer;
  }

  shutdown() {
    this._unregisterListeners();
    const prom = this._renderer._shutdown();
    this._renderer = undefined;
    this._value = undefined;
    return prom;
  }

  /* ***************************************** */
  /* END COMPONENT MODEL METHODS             */
  /* START HANDLER METHODS                   */
  /* ***************************************** */

  /* ***************************************** */
  /* END HANDLER METHODS                     */
  /* START PRIVATE METHODS                   */
  /* ***************************************** */
  _getLabelsForValues(values) {
    values = [].concat(values);
    const labels = _.get(this._context, ['typeInfo', 'labels']);
    const ids = _.get(this._context, ['typeInfo', 'ids'], []);
    if (labels) {
      values = values.map((value) => labels[ids.indexOf(value)]);
    }
    return values;
  }
  /* ***************************************** */
  /* END PRIVATE METHODS                     */
  /* START PUBLIC API METHODS                */
  /* ***************************************** */

  setValue(newVal) {
    if (!_.isUndefined(newVal)) {
      this._value = newVal;
      if (this._dataType === 'Enum') {
        newVal = this._getLabelsForValues(newVal);
      }
      this.emit('Value', newVal);
    }
  }

  getValue() {
    let value = this._value;
    if (this._dataType === 'Enum' && value) {
      value = this._getLabelsForValues(value);
    }
    return value;
  }

  /* ***************************************** */
  /* END PUBLIC API METHODS                  */
  /* ***************************************** */
}

export default AllowSiteAutoAssignmentComponent;
